import React from 'react';
import type { TextFieldProps } from '@mui/material/TextField';
import Styled from './TextFieldBox.styled';

const TextFieldBox: React.FC<TextFieldProps> = (props) => {
  return <Styled.TextFieldStyled {...props} />;
};

export default TextFieldBox;
